import { useRef } from "react";
import MagneticField from "../../applications/howitworks/MagneticField";
import { useEbbne } from "@solidwhite/ebbnen";
import { useFrame } from "@react-three/fiber";

const MagneticFieldOverviewTile = ({ node, ...props }) => {
  const { visible, active } = useEbbne();
  const magField = useRef();
  const sine = useRef(0);
  const sineTime = useRef(0);
  const animationSpeed = 0.7;

  useFrame(({ clock }) => {
    sine.current = Math.sin(clock.elapsedTime * animationSpeed);
    sineTime.current += sine.current * 0.003;

    if (magField.current) {
      magField.current.setOpacity(sine.current * sine.current);
      magField.current.setFlipped(sine.current < 0);
    }
  });

  return (
    <group>
      <MagneticField scene={node} ref={magField} brightness={1.5} segments={24} subdivisions={6} visible={!active} />
    </group>
  );
};

export default MagneticFieldOverviewTile;
